import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"
import { Layout } from "../../../../ui/layout"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { TrainingPopupEdit } from "../popup/edit"
import { GetAllTraining, resetTrainings, resetTrainingUpdateRequest, resetTrainingUpdateStatus, resetTrainingValidationStatus, TrainingUpdate, TrainingValidation } from "../slice"
import { colors } from "../../../../ui/colors"

export function EditTraining() {
    const trainingState = useAppSelector(state => state.PMTraining)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        if (trainingState.trainingValidationStatus === 'successfully') {
            dispatch(resetTrainingValidationStatus())
            dispatch(TrainingUpdate({ data: trainingState.trainingUpdateRequest, id: trainingState.trainingIdToUpdate }))
        }
    }, [trainingState.trainingValidationStatus])

    useEffect(() => {
        if (trainingState.trainingUpdateStatus === 'successfully') {
            dispatch(resetTrainingUpdateRequest())
            dispatch(resetTrainingUpdateStatus())
            dispatch(resetTrainings())
            dispatch(GetAllTraining(trainingState.getAllTrainingFilters))
            navigate('/formazione')
        }
    }, [trainingState.trainingUpdateStatus])

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_PERSONALE}
            breadcrumbItems={['Formazione dipendenti', 'Formazione', 'Modifica Formazione']}
            headerLabel="Modifica Formazione"
            rightBar={true}
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/formazione')} color={colors.brandPrimary[50]} size={0} />
            }
            headerChildren={
                <div className="flex items-center h-full w-full justify-end">
                    <ButtonComponent
                        size="sm"
                        iconPosition="off"
                        variant="solid"
                        label="Salva"
                        color="orange"
                        onClick={() => dispatch(TrainingValidation(trainingState.trainingUpdateRequest))}
                    />
                </div>
            }
        >
            <div>
                <TrainingPopupEdit />
            </div>
        </Layout>
    )
}